import {
  cycleCountIdFormat,
  cycleCountRuleIdFormat,
  locationIdFormat,
} from "@redotech/redo-inventory-id";
import {
  AdvancedFilterDataSchema,
  FilterGroupSchema,
} from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import { SortDirectionSchema } from "@redotech/redo-views-common/table";
import { taskIdFormat } from "@redotech/redo-warehouse-id";
import { unaryRpc } from "@redotech/rpc/definition";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const cycleCountStatusSchema = createEnum([
  "todo",
  "in_progress",
  "needs_review",
  "completed",
  "cancelled",
]);
export const cycleCountSourceSchema = createEnum(["auto", "manual"]);

/** What a count walks through: the products in it, or the bins in it. */
export const cycleCountTargetTypeSchema = z.enum(["items", "bins"]);

const item = z.object({
  id: cycleCountIdFormat.schema,
  taskId: taskIdFormat.schema.nullable(),
  name: z.string().nullable(),
  status: cycleCountStatusSchema,
  source: cycleCountSourceSchema,
  locationId: locationIdFormat.schema,
  locationName: z.string(),
  cycleCountRuleId: cycleCountRuleIdFormat.schema.nullable(),
  ruleName: z.string().nullable(),
  totalLines: z.int(),
  countedLines: z.int(),
  productCount: z.int(),
  binCount: z.int(),
  targetType: cycleCountTargetTypeSchema,
  assignedRole: z.string().nullable(),
  assignedUserId: z.string().nullable(),
  dueAt: z.date().nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
  startedAt: z.date().nullable(),
  /** Absolute units off across counted lines; null until something is counted. */
  variance: z.int().nullable(),
});

export const listCycleCounts = unaryRpc({
  name: "listCycleCounts" as const,
  input: z.object({
    search: z.string().optional(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).nullish(),
    filterGroup: FilterGroupSchema.nullish(),
    sortBy: z.string().nullish(),
    sortDirection: SortDirectionSchema.nullish(),
    pageSize: z.number().nullish(),
    pageNumber: z.number().nullish(),
  }),
  output: z.object({ totalCount: z.number(), cycleCounts: z.array(item) }),
});
